import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const SkipByRefreshTokenInterceptorContext = new HttpContextToken(
  () => true,
);

export const isSkippedByRefreshTokenInterceptorContext = <Body>(
  request: HttpRequest<Body>,
): boolean => {
  return request.context.has(SkipByRefreshTokenInterceptorContext);
};
